import { format } from 'date-fns';
import heLocale from 'date-fns/locale/he';
import enLocale from 'date-fns/locale/en-US';
import { Language } from '../types';
var formatTime = function (date, language) {
    return format(date, 'HH:mm', { locale: language === Language.He ? heLocale : enLocale });
};
export default formatTime;
//# sourceMappingURL=formatTime.js.map